import { Component, Input } from '@angular/core';
import { FormField } from '@nuso/forms/data-access';

@Component({
    selector: 'nuso-icon-button-input',
    templateUrl: './icon-button-input.component.html',
    styleUrls: ['./icon-button-input.component.css'],
    standalone: false
})
export class IconButtonInputComponent {
  @Input() field: FormField;
  defaultColor: '#000000';
}
